import { Button, Chip, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';
import { FilterIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { LocationFilter, StatusFilter, TopicsFilter } from '#src/app/pages/search/shared/components';

import { ClearAllFilters } from './components/ClearAllFilters';
import { useAllFiltersMobileButton } from './hooks/useAllFiltersMobileButton';

export const AllFiltersMobileButton: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: { nOfFilters },
	} = useAllFiltersMobileButton();

	return (
		<div className="relative">
			<Modal
				onClose={() => {}}
				closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
				trigger={
					<Chip
						as="button"
						forceInteractive
						leadingIcon={<FilterIcon size={18} />}
						active={nOfFilters > 0}
						size="small"
						count={nOfFilters > 0 ? nOfFilters : undefined}
					>
						<Translate value="corgi.search.filters.all_filters" />
					</Chip>
				}
			>
				<ModalHeader
					title={
						<Text variant="heading" size="small">
							<Translate value="corgi.search.filters.all_filters" />
						</Text>
					}
				/>

				<ModalBody className="min-h-[50vh]">
					<div className="flex w-full flex-col gap-12">
						<LocationFilter showTitle />
						<StatusFilter desktopView />
						<TopicsFilter showTitle trackingContext="topic_filter" />
					</div>
				</ModalBody>

				<ModalFooter>
					{({ close }) => (
						<>
							<Button variant="primary" onClick={close} className="w-full md:w-auto">
								<Translate value="corgi.search.filters.view_results" />
							</Button>
							<ClearAllFilters />
						</>
					)}
				</ModalFooter>
			</Modal>
		</div>
	);
};
